import { render } from "./InterestComment.vue?vue&type=template&id=2a388be9&scoped=true"
import script from "./InterestComment.vue?vue&type=script&lang=js"
export * from "./InterestComment.vue?vue&type=script&lang=js"

import "./InterestComment.vue?vue&type=style&index=0&id=2a388be9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a388be9"]])

export default __exports__